import axios from 'axios'
var Organization = {};

var _orgName = 'symbium_organizationName'
var _orgId = 'symbium_organizationId'
var _baseURL = process.env.VUE_APP_AUTH_API + '/organizations'

var getLocalOrganizationId = () => {
  return window.localStorage.getItem(_orgId)
}
var getLocalOrganizationName = () => {
  return window.localStorage.getItem(_orgName) || 'N/A'
}

Organization.install = function(Vue) {
  Vue.prototype.$organization = {
    setLocalOrganization(data) {
      window.localStorage.setItem(_orgName, data.name)
      window.localStorage.setItem(_orgId, data.id)
    },
    createUser(data, afterAddUser, afterFailedAddUser) {
      axios({
        method: 'POST',
        url: `${_baseURL}/${getLocalOrganizationId()}/users`,
        data,
        withCredentials: true,
      }).then(
        (response) => afterAddUser(response),
        (error) => afterFailedAddUser(error.response.data)
      )
    },
    removeUser(data, afterRemoveUser, afterFailedRemoveUser) {
      axios({
        method: 'DELETE',
        url: `${_baseURL}/${getLocalOrganizationId()}/users/1`,
        data,
        withCredentials: true,
      }).then(
        (response) => afterRemoveUser(response),
        (error) => afterFailedRemoveUser(error.response.data)
      )
    },
    fetchUsers(params, callback, errorCallback) {
      axios({
        method: 'GET',
        url: `${_baseURL}/${getLocalOrganizationId()}/users`,
        params,
        withCredentials: true,
      }).then((response) => {
        callback(response.data)
      }, (error) => {
        errorCallback(error)
      });
    },
    getLocalOrganizationName,
  }
}

export default Organization;
